import React from 'react';

import tgarden from '../assets/tgarden.png';
import ttots from '../assets/ttots.png';
import ttown from '../assets/ttown.png';
import tworld from '../assets/tworld.png';


const TinkerCourses = ({toSection,section}) => {
  const courses = [
    {
      title: "TINKER GARDEN",
      ageRange: "3-4",
      description: "Designed to have parents spend one hour of quality learning time with their child while experiencing the way their child understands the world around them.",
      color: "bg-[#B0CB1F]", // Green
      imageUrl: tgarden
    },
    {
      title: "TINKER TOTS",
      ageRange: "4-6",
      description: "Designed to improve graphomotor skills as well as cognitive understanding of STEAM subjects for children that have many questions parents don't know how to answer.",
      color: "bg-[#A064B4]", // Purple
      imageUrl: ttots
    },
    {
      title: "TINKER TOWN", 
      ageRange: "7-10",
      description: "Designed to introduce children to topics of math, physics, chemistry, biology, engineering and other STEM subjects through art and creative activities that go beyond traditional school methods and teach them that the world is in fact – interdisciplinary.",
      color: "bg-[#F18917]", // Orange
      imageUrl: ttown
    },
    {
      title: "TINKER WORLD",
      ageRange: "10-14", 
      description: "Designed to provide more historical and in depth context to scientific concepts through fun experiments that encourage children to explore the world through the eyes of inventors and scientists.",
      color: "bg-[#67B437]", // Green
      imageUrl: tworld
    }
  ];

  return (
    <div style={{marginTop: '-40px'}} id={section} className="relative">
      {/* Top wave */}
      <div style={{zIndex: 1}} className="absolute top-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '120px', transform: 'rotate(180deg)' }}
        >
          <path 
            fill="#c7e7ff"
            fillOpacity="1" 
            d="M0,160L48,144C96,128,192,96,288,80C384,64,480,64,576,80C672,96,768,128,864,128C960,128,1056,96,1152,80C1248,64,1344,64,1392,64L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>

      <div className="bg-[#fff] relative py-20 mb-20">
        <div className="container mx-auto px-4 py-10">
          <h2 className="font-['Grandstander'] text-center text-[#0a2247] text-3xl mb-16">
          Tinker Courses
          </h2>
          
          <div className="grid md:grid-cols-4  sm:grid-cols-1 gap-8">
            {courses.map((course, index) => (
              <div key={index} className="flex flex-col items-center">
                {/* Character Image */}
                <div style={{marginBottom:-10,zIndex:2}} className="relative mb-2">
                  <img 
                    src={course.imageUrl}
                    alt={course.title}
                    style={{height: '200px'}}
                    className="object-contain"
                  />
                </div>
                
                {/* Colored Block */}
                <div className={`${course.color} w-full rounded-xl px-6 py-4 text-center relative`}>
                  <h3 className="text-white font-['Grandstander'] font-bold text-3xl mb-2">
                    {course.title}
                  </h3>
                  <p className="text-white text-sm mb-1">
                    Ages {course.ageRange}
                  </p>
                  <p style={{minHeight:200}} className="text-white text-md font-['Lexend'] leading-snug ">
                    {course.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '120px' }}
        >
                
          <path 
            fill="#c7e7ff"
            d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,85.3C672,75,768,85,864,96C960,107,1056,117,1152,112C1248,107,1344,85,1392,74.7L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>
    </div>
  );
};

export default TinkerCourses;